module.exports = __webpack_public_path__ + "static/americano@2x-30a1c67a2fb405f7b68043536b47be0e.png";